<p-panel [toggleable]="toggleable()" toggler="header" [collapsed]="collapsed()">
  <ng-template #header>
    <app-panel-header
      class="grow"
      [titleKey]="titleKey()"
      [titleParams]="titleParams()"
      [tooltipKey]="tooltipKey()"
      [icon]="icon()"
      [iconColor]="iconColor()"
    >
      <ng-content select="[panelActions]" />
    </app-panel-header>
  </ng-template>

  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <ng-content />
</p-panel>
